/**
 * Generated runtime TestId mirror for frontend/src/features/inbound-connectors/InboundConnectorConfigLayout.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const InboundConnectorConfigLayoutTestIds = {
  inboundConfigLayout: "inbound-config-layout",
  inboundConfigLayoutMobile: "inbound-config-layout-mobile",
  selectConfigSubpage: "select-config-subpage",
  selectConfigSubpageOption: (item_href_split______pop: string) => `select-config-subpage-option-${item_href_split______pop}`,
  selectConfigSubpageOptionPrefix: () => "select-config-subpage-option-" as TestIdPrefix
} as const;
